{
	"title": "Όροι και Προϋποθέσεις",
	"backTitle": "Πίσω"
}
